module.exports = __webpack_public_path__ + "img/12_43.78351f2e.png";